export default "__VITE_ASSET__CzeeZZFm__"